import NotificationContentScreen from './NotificationContentScreen'

export default NotificationContentScreen
